import React, { useState, useEffect } from 'react';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

const RegistroPagos = () => {
  const [facturas, setFacturas] = useState([]);
  const [facturaSeleccionada, setFacturaSeleccionada] = useState(null);
  const [montoPago, setMontoPago] = useState('');
  const [mensaje, setMensaje] = useState('');

  useEffect(() => {
    const fetchFacturas = async () => {
      const snap = await getDocs(collection(db, 'facturasPorCobrar'));
      setFacturas(
        snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(f => f.estado !== 'pagada') // solo facturas pendientes
      );
    };
    fetchFacturas();
  }, []);

  const seleccionarFactura = (factura) => {
    setFacturaSeleccionada(factura);
    setMontoPago('');
    setMensaje('');
  };

  const registrarPago = async () => {
    if (!montoPago || isNaN(Number(montoPago)) || Number(montoPago) <= 0) {
      setMensaje('Error: Monto de pago inválido');
      return;
    }

    const nuevoPago = {
      monto: Number(montoPago),
      fecha: new Date().toISOString(),
    };

    const pagosPrevios = facturaSeleccionada.pagos || [];
    const totalPagado = pagosPrevios.reduce((acc, p) => acc + Number(p.monto), 0) + Number(montoPago);
    const estado = totalPagado >= facturaSeleccionada.total ? 'pagada' : 'abonada';

    try {
      await updateDoc(doc(db, 'facturasPorCobrar', facturaSeleccionada.id), {
        pagos: [...pagosPrevios, nuevoPago],
        estado: estado,
      });
      setMensaje('Pago registrado exitosamente');
      setFacturaSeleccionada(null);
      // Actualizar listado de facturas
      const snap = await getDocs(collection(db, 'facturasPorCobrar'));
      setFacturas(
        snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(f => f.estado !== 'pagada')
      );
    } catch (err) {
      setMensaje('Error al registrar el pago: ' + err.message);
    }
  };

  return (
    <div className="registro-pagos-container">
      <h2>Registro de Pagos de Facturas</h2>
      {mensaje && <div className={mensaje.includes('Error') ? "error" : "success"}>{mensaje}</div>}

      {!facturaSeleccionada ? (
        <>
          <h3>Facturas pendientes:</h3>
          <table>
            <thead>
              <tr>
                <th>N°</th>
                <th>Cliente</th>
                <th>Total ($)</th>
                <th>Abonado ($)</th>
                <th>Restante ($)</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              {facturas.map((f, i) => {
                const totalAbonado = (f.pagos || []).reduce((acc, p) => acc + Number(p.monto), 0);
                return (
                  <tr key={f.id}>
                    <td>{i + 1}</td>
                    <td>{f.clienteId || 'Sin cliente'}</td>
                    <td>${Number(f.total).toFixed(2)}</td>
                    <td>${totalAbonado.toFixed(2)}</td>
                    <td>${(Number(f.total) - totalAbonado).toFixed(2)}</td>
                    <td>
                      <button onClick={() => seleccionarFactura(f)}>Registrar Pago</button>
                    </td>
                  </tr>
                );
              })}
              {!facturas.length && (
                <tr>
                  <td colSpan={6} style={{ textAlign: 'center', color: '#777' }}>No hay facturas pendientes</td>
                </tr>
              )}
            </tbody>
          </table>
        </>
      ) : (
        <div style={{ marginTop: 32 }}>
          <h3>Registrar pago a factura</h3>
          <p><b>Cliente:</b> {facturaSeleccionada.clienteId}</p>
          <p><b>Total:</b> ${Number(facturaSeleccionada.total).toFixed(2)}</p>
          <p><b>Pagos anteriores:</b></p>
          <ul>
            {(facturaSeleccionada.pagos || []).map((p, idx) => (
              <li key={idx}>${p.monto} - {new Date(p.fecha).toLocaleString('es-VE')}</li>
            ))}
            {!(facturaSeleccionada.pagos || []).length && <li>No tiene pagos previos</li>}
          </ul>
          <label>
            Monto a abonar ($):
            <input
              type="number"
              value={montoPago}
              onChange={e => setMontoPago(e.target.value)}
              min={0}
              step="any"
            />
          </label>
          <br />
          <button onClick={registrarPago} style={{ marginTop: 18 }}>Registrar Pago</button>
          <button onClick={() => setFacturaSeleccionada(null)} style={{ marginLeft: 18 }}>Cancelar</button>
        </div>
      )}
    </div>
  );
};

export default RegistroPagos;

